let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3KLJ8")).then(() => parcelRequire('7kJWk'));